export default "__VITE_PUBLIC_ASSET__582ca5b8__"